/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnMobility } from './en-mobility';
 /**
 *
 *
 * @export
 * @interface MobilityDto
 */
export interface MobilityDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof MobilityDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof MobilityDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof MobilityDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof MobilityDto
     */
    deleted: string | null;

    /**
     * @type {EnMobility}
     * @memberof MobilityDto
     */
    name: EnMobility;

    /**
     * @type {number}
     * @memberof MobilityDto
     */
    order: number;

    /**
     * @type {number}
     * @memberof MobilityDto
     */
    minValue: number | null;

    /**
     * @type {number}
     * @memberof MobilityDto
     */
    maxValue: number | null;
}
